function HeroSection({ title, subtitle, tagline, cta, imagePc, imageMobile }) {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="hidden md:block relative w-full">
        <img
          src={imagePc}
          alt=""
          className="w-full h-auto block"
          style={{ minHeight: '400px', objectFit: 'cover' }}
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-pink-900/10 mix-blend-multiply" />
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4">
          <p className="font-montserrat text-xs sm:text-sm tracking-[0.3em] uppercase text-gold mb-6 fade-in">
            {tagline}
          </p>
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold mb-4 gold-gradient-text text-shadow-gold slide-up">
            {title}
          </h1>
          <p className="font-montserrat text-2xl md:text-3xl text-white/80 mb-10 italic fade-in" style={{ animationDelay: '0.3s' }}>
            {subtitle}
          </p>
          <a
            href="#contact"
            className="font-montserrat text-sm tracking-widest uppercase border-2 border-gold text-gold px-10 py-4 hover:bg-gold hover:text-dark transition-all duration-500 glow-gold fade-in"
            style={{ animationDelay: '0.6s' }}
          >
            {cta}
          </a>
        </div>
      </div>

      <div className="md:hidden relative w-full">
        <img
          src={imageMobile}
          alt=""
          className="w-full h-auto block"
        />
        <div className="hero-overlay absolute inset-0" />
        <div className="absolute inset-0 bg-gradient-to-r from-purple-900/20 to-pink-900/10 mix-blend-multiply" />
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center text-center px-4">
          <p className="font-montserrat text-xs tracking-[0.3em] uppercase text-gold mb-6 fade-in">
            {tagline}
          </p>
          <h1 className="font-playfair text-4xl sm:text-5xl font-bold mb-4 gold-gradient-text text-shadow-gold slide-up">
            {title}
          </h1>
          <p className="font-montserrat text-xl sm:text-2xl text-white/80 mb-10 italic fade-in" style={{ animationDelay: '0.3s' }}>
            {subtitle}
          </p>
          <a
            href="#contact"
            className="font-montserrat text-sm tracking-widest uppercase border-2 border-gold text-gold px-10 py-4 hover:bg-gold hover:text-dark transition-all duration-500 glow-gold fade-in"
            style={{ animationDelay: '0.6s' }}
          >
            {cta}
          </a>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
